import { render, staticRenderFns } from "./NewChatDialogHeader.vue?vue&type=template&id=1aa81a54&scoped=true&"
import script from "./NewChatDialogHeader.vue?vue&type=script&lang=js&"
export * from "./NewChatDialogHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewChatDialogHeader.vue?vue&type=style&index=0&id=1aa81a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa81a54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
